import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const sharingFieldRendererStyleId = 'sharing-field-renderer-theme';

export const sharingFieldRendererBridgeStyles = {
  '.cdk-overlay-container .sharing-field-renderer-overlay': {
    '--local-sharing-menu-min-width': '220px',
    '--local-sharing-menu-padding-y': tokens.spacing.xs,
    '--local-sharing-menu-row-padding-y': tokens.spacing.sm,
    '--local-sharing-menu-row-padding-x': tokens.spacing.lg,
    '--local-sharing-menu-divider': tokens.color.border.secondary,
    '--local-sharing-menu-divider-width': tokens.borderWidth.sm,
  },
};
